export default {
  state: {
    id: undefined,
    name: undefined,
    slug: undefined,
    description: undefined,
    puzzle_count: 0,
    free: undefined,
    free_trial: undefined,
    price: undefined,
    udids: undefined,
    subscription: false,
    subscription_interval: undefined,
    visible: true,
    starts_at: undefined,
    ends_at: undefined,
    visible_at: undefined,
    featured: true,
    recurring: false,
    loading: false,
    renewal: false,
    renewal_parent_id: undefined,
    puzzles: [],
    purchasable_item_attachments: [],
    relationships: {},
    tags: [],
    created_at: undefined,
    updated_at: undefined,
    external_payment_sandbox_id: undefined,
    external_payment_payment_id: undefined,
    external_payment_production_id: undefined,
    external_payment_id: undefined,
    external_payer_id: undefined,
    sandbox: undefined,
    purchase_url: undefined,
    subscription_starts_at: undefined,
    subscription_ends_at: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/PurchasableItemStore.js